import { useEffect, useState } from 'react';

const SECTIONS = [
  { id:'hero', label:'Home' },
  { id:'impact', label:'Impact' },
  { id:'identity', label:'Identity' },
  { id:'transformation', label:'Growth' },
  { id:'team', label:'Team' },
  { id:'activities', label:'Activities' },
  { id:'voices', label:'Voices' },
  { id:'footer', label:'End' },
];

export default function Nav() {
  const [active, setActive] = useState('hero');
  const [tooltip, setTooltip] = useState(null);

  useEffect(() => {
    const observers = SECTIONS.map(({ id }) => {
      const el = document.getElementById(id);
      if (!el) return null;
      const obs = new IntersectionObserver(
        ([e]) => { if (e.isIntersecting) setActive(id); },
        { threshold: 0.35 }
      );
      obs.observe(el);
      return obs;
    });
    return () => observers.forEach(o => o?.disconnect());
  }, []);

  return (
    <nav style={{ position:'fixed', right:'1.25rem', top:'50%', transform:'translateY(-50%)', zIndex:1000, display:'flex', flexDirection:'column', alignItems:'center', gap:'8px' }}>
      {SECTIONS.map(({ id, label }) => {
        const isActive = active === id;
        return (
          <div key={id} style={{ position:'relative', display:'flex', alignItems:'center' }}>
            {tooltip === id && (
              <span style={{
                position:'absolute', right:'20px',
                background:'var(--black)', color:'var(--white)',
                fontSize:'0.65rem', fontFamily:'var(--font-head)',
                fontWeight:700, letterSpacing:'0.06em', textTransform:'uppercase',
                padding:'4px 10px', borderRadius:2,
                border:'1.5px solid var(--black)',
                whiteSpace:'nowrap', pointerEvents:'none',
              }}>{label}</span>
            )}
            <a href={`#${id}`}
              onMouseEnter={() => setTooltip(id)}
              onMouseLeave={() => setTooltip(null)}
              style={{
                display:'block', width:'8px',
                height: isActive ? '32px' : '8px',
                borderRadius:'20px',
                background: isActive ? 'var(--accent)' : '#CCCCCC',
                border: isActive ? '1.5px solid var(--black)' : '1.5px solid transparent',
                transition:'all 0.3s cubic-bezier(0.34,1.56,0.64,1)',
                textDecoration:'none',
                boxShadow: isActive ? '2px 2px 0px var(--black)' : 'none',
              }}
            />
          </div>
        );
      })}
    </nav>
  );
}
